import nightbotIconRef from "./nightbot.png"
import twitchIconRef from "./twitch.svg"

export const nightbotIcon = nightbotIconRef
export const twitchIcon = twitchIconRef
